export default "__VITE_ASSET__cUqX6JIl__"